import { IonCardContent } from "@ionic/react";
import React from "react";
import { CartButton } from "./CartButton";
import { ProductPrice } from "./ProductPrice";
import classNames from "classnames/bind";
import styles from "./MainPageProduct.module.scss";
import { Product } from "@core/types";

const cx = classNames.bind(styles);

const CardContent = ({ product }: { product: Product }) => {
  return (
    <IonCardContent className={cx("cardFortimeContent", "product")}>
      <ProductPrice product={product} />
      <CartButton product={product} />
    </IonCardContent>
  );
};

export default CardContent;
